import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { customColumnProps } from "@maherunlocker/custom-react-table";
import { t } from "i18next";
import React from "react";
import { CustomIcons } from "./CustomIcons";
import { detailedDiff, diff } from "deep-object-diff";
import ErrorToast from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "@pages/SettingGeneral/Language/ShowSuccessToast";
import { setItemsDisable } from "@store";
import {
    setGlobalDataIsUpdated,
    setIsDataUpdated,
    setIsActionsClicked,
    setActions,
    setIsArchived,
    setIsLoading,
    setIsArchiveModalOpened,
    setArchivedData,
} from "../store";
import { toast } from "react-toastify";
import { isInformationModeConsumed } from "../hooks";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { LANGUAGES } from "@constants/index";
import { setPays } from "../../../../redux/globalSlice";
const ListOfPays = (e: any) => {
    let listPays: any = [];

    listPays =
        e.e.selectedRow.Country.labels !== undefined
            ? e.e.selectedRow.Country.labels
            : e.e.selectedRow.Pays.labels !== undefined
            ? e.e.selectedRow.Pays.labels
            : e.e.selectedRow.Pays !== undefined
            ? e.e.selectedRow.Pays
            : "";

    return (
        <CustomColumnDisplay
            text={`${
                Array.isArray(listPays)
                    ? listPays.join(",")
                    : e.e.selectedRow.Pays
            }`}
        />
    );
};

export const arrayOfCustomColumns = ({
    oneShop,
    selectedRows,
    userID,
    shopId,
    franchiseID,
    operatorID,
    uuidUser,
    setPaymentMethod,
    setIsAddChoiceClicked,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    setSelectedRows,
    isArchivedPaymentMethodsClicked,
    setIsConsult,
}: {
    oneShop: boolean;
    selectedRows: any[];
    userID: number;
    shopId: string;
    franchiseID: string;
    operatorID: string;
    uuidUser: any;
    setPaymentMethod: any;
    setIsAddChoiceClicked: any;
    setIsModalConfirmationOpened: any;
    isModalConfirmationOpened: boolean;
    setSelectedRows: any;
    isArchivedPaymentMethodsClicked: boolean;
    setIsConsult: any;
}): customColumnProps[] => [
    {
        indexOFColumn: 0,
        columnName: t("Display name"),
        customJsx: (e: any) => {
            return <CustomColumnDisplay text={e.selectedRow["Display name"]} />;
        },
    },
    {
        indexOFColumn: 1,
        columnName: t("Payment method"),
        customJsx: (e: any) => {
            return (
                <CustomColumnDisplay
                    text={e.selectedRow["Type of payment method"]}
                />
            );
        },
    },
    {
        indexOFColumn: 2,
        columnName: t("Country"),
        customJsx: (e: any) => {
            return <ListOfPays e={e} />;
        },
    },
    {
        indexOFColumn: 3,
        columnName: t("Sales support"),
        customJsx: (e: any) => {
            return (
                <CustomColumnDisplay text={e.selectedRow["Sales support"]} />
            );
        },
    },
    {
        indexOFColumn: oneShop ? 6 : 7,
        columnName: t("Actions"),
        customJsx: (e: any) => (
            <CustomIcons
                selectedRows={selectedRows}
                selectedRowData={e}
                userData={{
                    userId: userID,
                    shopId: shopId,
                    franchiseId: franchiseID,
                    operatorID: operatorID,
                    uuidUser: uuidUser,
                }}
                setPaymentMethod={setPaymentMethod}
                setIsAddChoiceClicked={setIsAddChoiceClicked}
                setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                isModalConfirmationOpened={isModalConfirmationOpened}
                setSelectedRows={setSelectedRows}
                isArchivedPaymentMethodsClicked={
                    isArchivedPaymentMethodsClicked
                }
                setIsConsult={setIsConsult}
            />
        ),
    },
];
export const translatedPaymentMethod: any = {
    [t("Cash")]: {
        fr: "Espèces",
        en: "Cash",
        nl: "Bargeld",
        es: "Efectivo",
        pt: "Dinheiro",
        it: "Cash",
    },
    [t("Checks")]: {
        fr: "Chèques",
        en: "Checks",
        nl: "Schecks",
        es: "Cheques",
        pt: "Cheques",
        it: "Assegni",
    },
    [t("Billets restaurants")]: {
        fr: "Tickets restaurants",
        en: "Billets restaurants",
        nl: "Restaurantschecks",
        es: "Vales de restaurante",
        pt: "Vales de restaurante",
        it: "Buoni pasto",
    },
    [t("Credit card")]: {
        fr: "Carte bancaire",
        en: "Credit card",
        nl: "Kreditkarte",
        es: "Tarjeta de crédito",
        pt: "Cartão de crédito",
        it: "Carta di credito",
    },
    [t("Online payment")]: {
        fr: "Paiement en ligne",
        en: "Online payment",
        nl: "Online-Zahlung",
        es: "Pago en línea",
        pt: "Pagamento online",
        it: "Pagamento online",
    },
    [t("Flash Restaurant")]: {
        fr: "Resto flash",
        en: "Flash Restaurant",
        nl: "Flash-Restaurant",
        es: "Flash Restaurante",
        pt: "Flash Restaurante",
        it: "Flash Ristorante",
    },
    [t("TPA")]: {
        fr: "TPA",
        en: "TPA",
        nl: "TPA",
        es: "TPA",
        pt: "TPA",
        it: " TPA",
    },
    [t("Gift")]: {
        fr: "Cadeau",
        en: "Gift",
        nl: "Geschenk",
        es: "Regalo",
        pt: "Presente",
        it: "Regalo",
    },
    [t("Vacation check")]: {
        fr: "Chèque vacances",
        en: "Vacation check",
        nl: "Geschenk",
        es: "Regalo",
        pt: "Presente",
        it: "Regalo",
    },
    [t("Sampling")]: {
        fr: "Prélèvement",
        en: "Sampling",
        nl: "Urlaubscheck",
        es: "Cheque de vacaciones",
        pt: "Cheque de férias",
        it: "Assegno vacanza",
    },
    [t("Payment")]: {
        fr: "Paiement",
        en: "Payment",
        nl: "Zahlung",
        es: "Pago",
        pt: "Pagamento",
        it: "Pagamento",
    },
};

export function getUpdatedSaleSupport(oldData: any, newData: any) {
    try {
        const diff1: any = detailedDiff(oldData, newData);
        let isSaleSupportKIOSKDeleted = false;
        let isSaleSupportKIOSKAdded = false;
        let isPaymentMethodHasSaleSupportKIOSK = false;
        let saleSupportDeleted: any = [];
        if (Object.keys(diff1.deleted).length > 0) {
            if (diff1.deleted["saleSupport"] !== undefined) {
                const saleSupportValues = diff1.deleted["saleSupport"].split(
                    ","
                );
                [saleSupportValues].forEach((element: number) => {
                    saleSupportDeleted.push(oldData["saleSupport"][element]);
                });

                if (saleSupportDeleted.includes("KIOSK")) {
                    isSaleSupportKIOSKDeleted = true;
                }
            }
        }
        if (Object.keys(diff1.updated).length > 0) {
            if (diff1.updated["saleSupport"] !== undefined) {
                const saleSupportUpdated = diff1.updated["saleSupport"].split(
                    ","
                );

                if (saleSupportUpdated.includes("KIOSK") === false) {
                    if (
                        oldData.saleSupport.split(",").includes("KIOSK") ===
                        true
                    ) {
                        isSaleSupportKIOSKDeleted = true;
                    } else {
                        isSaleSupportKIOSKDeleted = false;
                    }
                } else if (saleSupportUpdated.includes("KIOSK") === true) {
                    if (
                        oldData.saleSupport.split(",").includes("KIOSK") ===
                        true
                    ) {
                        isSaleSupportKIOSKAdded = false;
                    } else {
                        isSaleSupportKIOSKAdded = true;
                    }
                }
            }
        }
        if (Object.keys(diff1.added).length > 0) {
            if (diff1.added.saleSupport !== undefined) {
                const saleSupportAdded = Object.values(diff1.added.saleSupport);
                if (saleSupportAdded.includes("KIOSK") === true) {
                    isSaleSupportKIOSKAdded = true;
                }
            }
        }

        const modifiedDisplayName = detailedDiff(
            oldData.advancedDisplayName,
            newData.advancedDisplayName
        );

        if (
            isSaleSupportKIOSKAdded === false &&
            isSaleSupportKIOSKDeleted === false &&
            newData.saleSupport.includes("KIOSK") === true
        ) {
            return {
                modifiedDisplayName,
                isSaleSupportKIOSKAdded,
                isSaleSupportKIOSKDeleted,
                isPaymentMethodHasSaleSupportKIOSK,
            };
        } else if (
            isSaleSupportKIOSKAdded === false &&
            isSaleSupportKIOSKDeleted === false &&
            newData.saleSupport.includes("KIOSK") === false
        ) {
            return {};
        } else {
            return {
                modifiedDisplayName,
                isSaleSupportKIOSKAdded,
                isSaleSupportKIOSKDeleted,
            };
        }
    } catch (error) {
        console.log({ error });
        throw error;
    }
}

export const formatCreateLabel = (inputValue: any, type: any) => {
    try {
        return (
            <span>
                {inputValue} ({t(type)})
            </span>
        );
    } catch (error) {
        console.log({ error });
        throw error;
    }
};

export function fetchDataNameFranchiseArchived(
    listFranchiseArchived: any,
    dataArchive: any
) {
    try {
        let localNamesFranchise: string[] = [];
        if (listFranchiseArchived !== undefined && dataArchive !== undefined) {
            listFranchiseArchived.forEach((el: any) => {
                localNamesFranchise.push(
                    `${el[t("Type of payment method")].toUpperCase()}`
                );
            });
        }
        return localNamesFranchise;
    } catch (error) {
        console.log({ error });
        throw error;
    }
}

export function checkPmFranchiseExistAndArchived(
    archivedModesInFranchise: any,
    choiceMode: any
) {
    try {
        let isModeOfSaleExist = false;

        if (archivedModesInFranchise !== undefined)
            archivedModesInFranchise.forEach((el: any) => {
                if (el["Type of payment method"] === choiceMode)
                    isModeOfSaleExist = true;
                return;
            });

        return isModeOfSaleExist;
    } catch (error) {
        console.log({ error });
        throw error;
    }
}

export const checkIfPaymentMethodFranchiseExist = (
    paymentMethodList: any,
    choiceMode: any,
    allDataShops: any
) => {
    try {
        let id = paymentMethodList.find((elt: any) => elt.label === choiceMode)
            .value;
        let isPaymentMethodExist: boolean = false;
        if (allDataShops !== undefined) {
            isPaymentMethodExist =
                allDataShops.find((el: any) => el.id === id) !== undefined;
        }

        return isPaymentMethodExist;
    } catch (error) {
        console.log({ error });
        throw error;
    }
};

export async function handleGetPaymentMethodsTagsButtonOnClickEvent(
    i18nextLng: any,
    franchiseID: any,
    shopID: any,
    setTags: any,
    setLanguage: any,
    setSalesSupportData: any,
    setOriginPaymentMethodList: any,
    setPaymentMethodList: any,
    listOfCountry: any,
    dispatch: Function,
    fetchGlobal: any
) {
    if (!dispatch || typeof dispatch !== "function") {
        console.error("dispatch is invalid!");
        return;
    }
    const headers = new Headers();
    headers.append("Accept-Language", i18nextLng);

    try {
        const savedData: any = {
            franchiseId: franchiseID,
            shopId: shopID,
            types: "payment_method",
        };

        const queryString = new URLSearchParams(savedData).toString();
        const data: any = await fetchGlobal(
            `${process.env.REACT_APP_API_V2_URL}/settings/general/setup?${queryString}`,
            {
                method: "GET",
            }
        );
        const shopId = shopID === "0" ? 0 : shopID;
        await fetchPaysIfNeeded(
            listOfCountry,
            dispatch,
            i18nextLng,
            fetchGlobal
        );
        if (data.data[shopId].setting_language !== undefined) {
            const translatedLanguage = data.data[shopId].setting_language.map(
                (method: any) => ({
                    ...method,
                    language: t(method.language),
                })
            );
            setLanguage(translatedLanguage);
        }
        if (data.data[shopId].setting_sale_support !== undefined) {
            setSalesSupportData(data.data[shopId].setting_sale_support);
        }

        setOriginPaymentMethodList(data.data[0].payment_method_list);
        const translatedLabels = data.data[0].payment_method_list.map(
            (method: any) => ({
                ...method,
                label: t(method.label),
            })
        );
        setPaymentMethodList(translatedLabels);
        if (data.data[shopId].tag !== undefined) {
            setTags(data.data[shopId].tag);
        }
    } catch (error) {
        console.log(error);
    }
}

export function handleValidateButtonOnClickEvent(
    i18nextLng: any,
    archivedModesInFranchise: any,
    choiceMode: any,
    setInputChoiceMode: any,
    setIsValidateButtonDisabled: any,
    advancedDisplayName: any,
    setInputDisplay: any,
    countryData: any,
    setSelectCountry: any,
    salesSupport: any,
    setInputSaleSupport: any,
    isNameExist: any,
    paymentMethod: any,
    allDataShops: any,
    tagsData: any,
    isModalOpened: any,
    userData: any,
    setIsModalOpened: any,
    allAssociatedCountryShop: any,
    countryList: any,
    oneShop: any,
    shopsPaymentMethodsData: any,
    setIdsAssociated: any,
    identifier: any,
    setIsPaymentMethodAssociatedModified: any,
    setIsMessageModalOpened: any,
    isMessageModalOpened: any,
    display: any,
    paymentMethodList: any,
    dataArchive: any,
    listFranchiseArchived: any,
    operatorID: any,
    setIsSendingTag: any,
    uuidUser: any,
    setDataChoice: any,
    setIsEdited: any,
    setTagsData: any,
    setCountryData: any,
    setSalesSupport: any,
    setAdvancedDisplayName: any,
    setIsAddChoiceClicked: any,
    isAddChoiceClicked: any,
    setLocalFilterActive: any,
    itemsDisable: any,
    originPaymentMethodList: any,
    fetchGlobal: any
) {
    try {
        let idsAssociated: any = [];
        let idsShopsAssociated: any = ["0"];
        let isPmFranchiseExistAndArchived = checkPmFranchiseExistAndArchived(
            archivedModesInFranchise,
            choiceMode
        );
        if (choiceMode === "") {
            setInputChoiceMode(true);
            setIsValidateButtonDisabled(false);
        }
        if (advancedDisplayName.languages[i18nextLng] === "") {
            setInputDisplay(true);
            setIsValidateButtonDisabled(false);
        }

        if (countryData.length === 0) {
            setSelectCountry(true);
            setIsValidateButtonDisabled(false);
        }
        if (salesSupport.length === 0) {
            setInputSaleSupport(true);
            setIsValidateButtonDisabled(false);
        }

        if (isNameExist === true) {
            setIsValidateButtonDisabled(false);
        }

        if (paymentMethod.id) {
            let samePaymentMethod: any = allDataShops.find(
                (el: any) =>
                    `${el[t("Type of payment method")].toUpperCase()}` ===
                    `${choiceMode.toUpperCase()}`
            );
            let isTagNotModified: any =
                samePaymentMethod !== undefined &&
                samePaymentMethod?.Tag === tagsData.join(",");

            let isCountryNotModified: any =
                samePaymentMethod !== undefined &&
                samePaymentMethod?.Pays === countryData.join(",");

            let isSalesSupportModified: any =
                samePaymentMethod !== undefined &&
                samePaymentMethod["Sales support"] === salesSupport.join(",");

            if (
                salesSupport.length !== 0 &&
                choiceMode !== "" &&
                advancedDisplayName.languages[i18nextLng].trim() !== "" &&
                countryData.length !== 0 &&
                !isNameExist
            ) {
                if (
                    isTagNotModified &&
                    isCountryNotModified &&
                    isSalesSupportModified &&
                    Object.keys(
                        diff(
                            paymentMethod.advancedDisplayName,
                            advancedDisplayName
                        )
                    ).length === 0
                ) {
                    setIsLoading(false);
                    setIsModalOpened(!isModalOpened);
                    setIsValidateButtonDisabled(false);
                } else if (
                    allAssociatedCountryShop
                        .map((el: any) =>
                            oneShop
                                ? [...new Set([...countryData, ...countryList])]
                                : [
                                      ...new Set([
                                          ...countryData,
                                          ...allAssociatedCountryShop,
                                      ]),
                                  ].includes(el)
                        )
                        .find((el: any) => el === false) !== undefined
                ) {
                    ErrorToast(
                        `${t(
                            "Please note that you cannot remove the country from a payment method used in a store"
                        )}.`
                    );
                    setIsValidateButtonDisabled(false);
                } else if (userData.shopId === "0") {
                    shopsPaymentMethodsData.forEach((el: any) => {
                        el.subRows.forEach((element: any) => {
                            if (element.id === paymentMethod.id) {
                                idsAssociated.push(element.id);
                                idsShopsAssociated.push(element.idShop);
                            }
                        });
                    });
                    setIdsAssociated([...new Set(idsShopsAssociated)]);
                    if (idsAssociated.includes(identifier)) {
                        setIsPaymentMethodAssociatedModified(true);
                    } else {
                        editPaymentMethod(
                            userData,
                            operatorID,
                            uuidUser,
                            identifier,
                            display,
                            choiceMode,
                            oneShop,
                            countryList,
                            countryData,
                            allAssociatedCountryShop,
                            salesSupport,
                            paymentMethod,
                            tagsData,
                            advancedDisplayName,
                            i18nextLng,
                            idsAssociated,
                            setIsSendingTag,
                            setIsPaymentMethodAssociatedModified,
                            setIsValidateButtonDisabled,
                            setDataChoice,
                            setIsEdited,
                            setTagsData,
                            setCountryData,
                            setSalesSupport,
                            setAdvancedDisplayName,
                            setIsAddChoiceClicked,
                            isAddChoiceClicked,
                            fetchGlobal
                        );
                    }
                } else {
                    editPaymentMethod(
                        userData,
                        operatorID,
                        uuidUser,
                        identifier,
                        display,
                        choiceMode,
                        oneShop,
                        countryList,
                        countryData,
                        allAssociatedCountryShop,
                        salesSupport,
                        paymentMethod,
                        tagsData,
                        advancedDisplayName,
                        i18nextLng,
                        idsAssociated,
                        setIsSendingTag,
                        setIsPaymentMethodAssociatedModified,
                        setIsValidateButtonDisabled,
                        setDataChoice,
                        setIsEdited,
                        setTagsData,
                        setCountryData,
                        setSalesSupport,
                        setAdvancedDisplayName,
                        setIsAddChoiceClicked,
                        isAddChoiceClicked,
                        fetchGlobal
                    );
                }
            }
        } else if (
            salesSupport.length !== 0 &&
            choiceMode !== "" &&
            advancedDisplayName.languages[i18nextLng].trim() !== "" &&
            countryData.length !== 0 &&
            !isNameExist
        ) {
            if (
                fetchDataNameFranchiseArchived(
                    listFranchiseArchived,
                    dataArchive
                ).includes(`${choiceMode.toUpperCase()}`)
            ) {
                setIsValidateButtonDisabled(false);
            } else if (
                allDataShops !== undefined &&
                checkIfPaymentMethodFranchiseExist(
                    paymentMethodList,
                    choiceMode,
                    allDataShops
                )
            ) {
                setIsMessageModalOpened(true);
                setIsValidateButtonDisabled(false);
                setIsArchived(false);
            } else if (isPmFranchiseExistAndArchived && oneShop) {
                setIsMessageModalOpened(true);
                setIsArchived(true);
                setIsValidateButtonDisabled(false);
            } else {
                let id = paymentMethodList.find(
                    (elt: any) => elt.label === choiceMode
                ).value;

                addPaymentMethod({
                    id,
                    choiceMode,
                    display,
                    salesSupport: salesSupport.join(","),
                    country: countryData.join(","),
                    tag: tagsData.join(","),
                    shopIds:
                        userData.shopId === "0"
                            ? ["0"]
                            : [userData.shopId, "0"],
                    isActive: false,
                    msg: "The payment method has been added successfully",
                    isAffectation: false,
                    paymentMethodList,
                    originPaymentMethodList,
                    userData,
                    operatorID,
                    uuidUser,
                    advancedDisplayName,
                    oneShop,
                    i18nextLng,
                    itemsDisable,
                    setIsSendingTag,
                    setIsEdited,
                    setLocalFilterActive,
                    setTagsData,
                    setCountryData,
                    setSalesSupport,
                    setDataChoice,
                    setAdvancedDisplayName,
                    setIsValidateButtonDisabled,
                    fetchGlobal,
                });
            }
        }
    } catch (error) {
        console.log({ error });
        throw error;
    }
}

async function editPaymentMethod(
    userData: any,
    operatorID: any,
    uuidUser: any,
    identifier: any,
    display: any,
    choiceMode: any,
    oneShop: any,
    countryList: any,
    countryData: any,
    allAssociatedCountryShop: any,
    salesSupport: any,
    paymentMethod: any,
    tagsData: any,
    advancedDisplayName: any,
    i18nextLng: any,
    idsAssociated: any,
    setIsSendingTag: any,
    setIsPaymentMethodAssociatedModified: any,
    setIsValidateButtonDisabled: any,
    setDataChoice: any,
    setIsEdited: any,
    setTagsData: any,
    setCountryData: any,
    setSalesSupport: any,
    setAdvancedDisplayName: any,
    setIsAddChoiceClicked: any,
    isAddChoiceClicked: any,
    fetchGlobal: any
) {
    try {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;
        let dataConfig = {
            userId: userData.userId,
            shopId: [userData.shopId],
            franchiseId: userData.franchiseId,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [identifier]: {
                    designation: choiceMode,
                    display: display,
                    shopId: [userData.shopId],
                    country: oneShop
                        ? [...new Set([...countryData, ...countryList])].join(
                              ","
                          )
                        : [
                              ...new Set([
                                  ...countryData,
                                  ...allAssociatedCountryShop,
                              ]),
                          ].join(","),
                    saleSupport: salesSupport.join(","),
                    languages: paymentMethod.languages,
                    tag: tagsData.join(","),
                    isActive: paymentMethod.isActive,
                    isArchived: paymentMethod.isArchived,
                    advancedDisplayName: advancedDisplayName,
                },
            },
        };

        let oldData = {
            designation: choiceMode,
            display: paymentMethod["Display name"],
            shopId: userData.shopId,
            country: paymentMethod.Country,
            saleSupport: paymentMethod["Sales support"],
            languages: paymentMethod.languages,
            tag: paymentMethod.Tag,
            isActive: paymentMethod.isActive,
            isArchived: paymentMethod.isArchived,
            advancedDisplayName: paymentMethod.advancedDisplayName,
        };

        let updatedData = getUpdatedSaleSupport(
            oldData,
            dataConfig.data[identifier]
        );

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
            body: JSON.stringify({ dataConfig, updatedData }),
        };
        try {
            const data: any = await fetchGlobal(apiUrl, requestOptions);
            if (data.error) {
                throw Error("error");
            }
            setIsDataUpdated(true);
            ShowSuccessToast(
                `${t("The payment method is successfully changed")!}`
            );
            setIsSendingTag(true);
            if (userData.shopId === "0" && idsAssociated.includes(identifier)) {
                setIsLoading(false);
                setIsPaymentMethodAssociatedModified(true);
                setIsValidateButtonDisabled(false);
            } else {
                setDataChoice([]);
                setIsAddChoiceClicked(!isAddChoiceClicked);
                setIsEdited(false);
                clearData();
                clearMultiCustomSelectionData();
                setTagsData([]);
                setCountryData([]);
                setSalesSupport([]);
                // setIsDataUpdated(true);
                setAdvancedDisplayName({
                    languages: LANGUAGES,
                });
                setIsValidateButtonDisabled(false);
            }
        } catch (e) {
            ErrorToast(`${e}`);
            setIsValidateButtonDisabled(false);
        }
    } catch (error) {
        throw error;
    }
}

export async function addPaymentMethod({
    id,
    choiceMode,
    display,
    salesSupport,
    country,
    tag,
    shopIds,
    isActive,
    msg,
    isAffectation,
    paymentMethodList,
    originPaymentMethodList,
    userData,
    operatorID,
    uuidUser,
    advancedDisplayName,
    oneShop,
    i18nextLng,
    itemsDisable,
    setIsSendingTag,
    setIsEdited,
    setLocalFilterActive,
    setTagsData,
    setCountryData,
    setSalesSupport,
    setDataChoice,
    setAdvancedDisplayName,
    setIsValidateButtonDisabled,
    fetchGlobal,
}: any) {
    try {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

        const pmItem = paymentMethodList.find((el: any) => el.value === id);
        if (!pmItem) throw new Error("Invalid payment method ID");

        const idPm = pmItem.value;
        const pmLocalItem = originPaymentMethodList.find(
            (el: any) => el.value === idPm
        );
        const pmLocal = pmLocalItem ? pmLocalItem.label : idPm;

        const data = {
            userId: userData.userId,
            shopId: shopIds,
            franchiseId: userData.franchiseId,
            affectation: isAffectation,
            operatorId: operatorID,
            uuidUser: uuidUser,
            adding: true,
            data: {
                [id]: {
                    designation: choiceMode,
                    display: display,
                    shopId: shopIds,
                    country: country,
                    saleSupport: salesSupport,
                    tag: tag,
                    languages: {
                        fr: {
                            designation: t(pmLocal, { lng: "fr" }),
                            displayName: display,
                        },
                        en: {
                            designation: t(pmLocal, { lng: "en" }),
                            displayName: display,
                        },
                        es: {
                            designation: t(pmLocal, { lng: "es" }),
                            displayName: display,
                        },
                        al: {
                            designation: t(pmLocal, { lng: "al" }),
                            displayName: display,
                        },
                        it: {
                            designation: t(pmLocal, { lng: "it" }),
                            displayName: display,
                        },
                        pt: {
                            designation: t(pmLocal, { lng: "pt" }),
                            displayName: display,
                        },
                    },
                    isActive: isActive,
                    isArchived: false,
                    advancedDisplayName: advancedDisplayName,
                },
            },
        };
        if (oneShop) {
            const newItemsDisable = [
                ...itemsDisable,
                { id, state: false, shopId: userData.shopId },
            ];
            setItemsDisable(newItemsDisable);
        }

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
            body: JSON.stringify(data),
        };

        const result: any = await fetchGlobal(apiUrl, requestOptions);
        if (result.error) throw new Error(result.error);

        if (msg !== "false") {
            ShowSuccessToast(t(msg));
            setIsSendingTag(true);
            setIsDataUpdated(true);
            setIsEdited(false);
            setLocalFilterActive(false);
            setTagsData([]);
            setCountryData([]);
            setSalesSupport([]);
            setDataChoice([]);
            clearData();
            clearMultiCustomSelectionData();
            setAdvancedDisplayName({
                languages: LANGUAGES,
            });
            setIsValidateButtonDisabled(false);
        }
    } catch (e: any) {
        ErrorToast(e);
        setIsValidateButtonDisabled(false);
    }
}

export const handleTrashButtonClicked = async (
    selectedRow: any,
    shopsPaymentMethodsData: any,
    franchiseID: any,
    isArchivedValidationModalOpened: any,
    setIsArchivedValidationModalOpened: any,
    fetchGlobal: any
) => {
    try {
        let idsAssociated: any = [];
        shopsPaymentMethodsData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.id);
            });
        });

        if (
            selectedRow.idShop === "0" &&
            idsAssociated.includes(selectedRow.id)
        ) {
            ErrorToast(
                `${t(
                    "Please note that you cannot archive an item assigned to stores."
                )!}`
            );
            setIsLoading(false);
        } else {
            let dataConsumed: any = await isInformationModeConsumed(
                selectedRow.idShop,
                franchiseID,
                fetchGlobal
            );

            let isConsumed = dataConsumed.some(
                (elt: any) => elt.id === selectedRow.id
            );

            if (isConsumed === true) {
                ErrorToast(
                    t(
                        "Please note, you cannot archive an element used in a template"
                    )
                );
                setIsLoading(false);
            } else {
                setIsLoading(false);
                setIsArchivedValidationModalOpened(
                    !isArchivedValidationModalOpened
                );
            }
        }
    } catch (error) {
        console.log({ error });
        throw error;
    }
};

export async function handleStateChange(
    state: any,
    userData: any,
    selectedRowData: any,
    operatorID: any,
    uuidUser: any,
    choiceState: any,
    itemsDisable: any,
    fetchGlobal: any
) {
    try {
        setIsLoading(true);
        let dataConfig = {
            userId: userData.userId,
            shopId: [selectedRowData.selectedRow.idShop],
            franchiseId: userData.franchiseId,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [selectedRowData.selectedRow.id]: {
                    designation:
                        selectedRowData.selectedRow[
                            t("Type of payment method")
                        ],
                    currency: selectedRowData.selectedRow.Devise,
                    display: selectedRowData.selectedRow[t("Display name")],
                    saleSupport:
                        selectedRowData.selectedRow[t("Support de vente")],
                    shopId: userData.shopId,
                    languages: selectedRowData.selectedRow.languages,
                    country: selectedRowData.selectedRow[t("Country")],
                    tag: selectedRowData.selectedRow.Tag,
                    isActive: state,
                    isArchived: selectedRowData.selectedRow.isArchived,
                    advancedDisplayName:
                        selectedRowData.selectedRow.advancedDisplayName,
                },
            },
        };

        const isStateChange = true;
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ dataConfig, isStateChange }),
        };

        const result: any = await fetchGlobal(apiUrl, requestOptions);
        if (result.error) {
            throw Error(result.message);
        }
        ShowSuccessToast(
            state === true
                ? `${t("Payment method has been successfully activated")}`
                : `${t("Payment method has been successfully deactivated")}`
        );

        setIsLoading(false);
        if (!choiceState === false) {
            const item = [
                ...JSON.parse(JSON.stringify(itemsDisable)),
                {
                    id: selectedRowData.selectedRow.id,
                    state: !choiceState,
                    shopId: selectedRowData.selectedRow.idShop,
                },
            ];
            setItemsDisable(item);
        } else if (!choiceState === true) {
            const item = itemsDisable.filter(
                (item: any) =>
                    !(
                        item.id === selectedRowData.selectedRow.id &&
                        item.shopId === selectedRowData.selectedRow.idShop
                    )
            );
            setItemsDisable(item);
        }
        setIsDataUpdated(true);
    } catch (error) {
        ErrorToast(`${t("There's an error")}`);
        setIsLoading(false);
    }
}

export async function handleActivePaymentMethod(
    selectedRowData: any,
    userData: any,
    operatorID: any,
    uuidUser: any,
    itemsDisable: any,
    fetchGlobal: any
) {
    try {
        let dataConfig = {
            userId: userData.userId,
            shopId: [selectedRowData.selectedRow.idShop],
            franchiseId: userData.franchiseId,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [selectedRowData.selectedRow.id]: {
                    designation:
                        selectedRowData.selectedRow[
                            t("Type of payment method")
                        ],
                    currency: selectedRowData.selectedRow.Devise,
                    display: selectedRowData.selectedRow[t("Display name")],
                    languages: selectedRowData.selectedRow.languages,
                    shopId: [selectedRowData.selectedRow.idShop],
                    saleSupport:
                        selectedRowData.selectedRow[t("Support de vente")],
                    country: selectedRowData.selectedRow[t("Country")],
                    tag: selectedRowData.selectedRow.Tag,
                    isActive:
                        selectedRowData.selectedRow.idShop === "0"
                            ? true
                            : false,
                    isArchived: false,
                    advancedDisplayName:
                        selectedRowData.selectedRow.advancedDisplayName,
                },
            },
        };
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataConfig),
        };

        const result: any = await fetchGlobal(apiUrl, requestOptions);

        if (result.error) {
            throw Error(result.message);
        }
        setIsLoading(false);
        setIsDataUpdated(true);
        ShowSuccessToast(t("The Payment method is successfully unarchived"));

        if (selectedRowData.selectedRow.idShop !== "0") {
            if (
                itemsDisable.find(
                    (item: any) =>
                        item.id === selectedRowData.selectedRow.id &&
                        item.shopId === selectedRowData.selectedRow.idShop
                ) === undefined
            ) {
                const item = [
                    ...JSON.parse(JSON.stringify(itemsDisable)),
                    {
                        id: selectedRowData.selectedRow.id,
                        state: false,
                        shopId: selectedRowData.selectedRow.idShop,
                    },
                ];
                setItemsDisable(item);
            }
        }
    } catch (error) {
        ErrorToast(`${t("There's an error")}`);
        setIsLoading(false);
    }
}

export async function handleArchivePaymentMethod(
    element: any,
    selectedRowData: any,
    isArchiveModalOpened: any,
    userData: any,
    operatorID: any,
    uuidUser: any,
    setIsArchivedValidationModalOpened: any,
    itemsDisable: any,
    setIsValidateClicked: any,
    fetchGlobal: any
) {
    try {
        setIsLoading(true);
        setIsValidateClicked(false);
        setArchivedData(selectedRowData);
        setIsArchiveModalOpened!(!isArchiveModalOpened);
        let dataConfig = {
            userId: userData.userId,
            shopId: [element.idShop],
            franchiseId: userData.franchiseId,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [element.id]: {
                    designation: element[t("Type of payment method")],
                    currency: element.Devise,
                    display: selectedRowData.selectedRow[t("Display name")],
                    saleSupport:
                        selectedRowData.selectedRow[t("Support de vente")],
                    shopId: [element.idShop],
                    country: element[t("Country")],
                    tag: element.Tag,
                    languages: element.languages,
                    isActive: element.idShop === "0" ? true : false,
                    isArchived: true,
                    advancedDisplayName:
                        selectedRowData.selectedRow.advancedDisplayName,
                },
            },
        };
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataConfig),
        };
        const result: any = await fetchGlobal(apiUrl, requestOptions);

        if (result.error) {
            throw Error(result.message);
        }
        setIsDataUpdated(true);
        setIsLoading(false);
        setIsArchivedValidationModalOpened(false);
        ShowSuccessToast(`${t("The Payment method is successfully archived")}`);

        const item = itemsDisable.find(
            (item: any) =>
                item.id === selectedRowData.selectedRow.id &&
                item.shopId === selectedRowData.selectedRow.idShop
        );
        if (item !== undefined) {
            const item = itemsDisable.filter(
                (item: any) =>
                    !(
                        item.id === selectedRowData.selectedRow.id &&
                        item.shopId === selectedRowData.selectedRow.idShop
                    )
            );
            setItemsDisable(item);
        }
    } catch (error) {
        ErrorToast(`${t("There's an error")}`);
        setIsLoading(false);
    }
}

export async function isSaleSupportArchived(
    i18nextLng: any,
    selectedRowData: any,
    userID: any,
    shopId: any,
    franchiseID: any,
    fetchGlobal: any
) {
    let isSaleSupportArchived = false;
    try {
        toast.dismiss();
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=archived`;
        const data: any = await fetchGlobal(url, {
            method: "GET",
            headers: { "Accept-Language": i18nextLng },
        });

        data.data.forEach((elt: any) => {
            selectedRowData.forEach((row: any) => {
                if (
                    row[t("Sales support")]
                        .split(",")
                        .includes(elt[t("Sale support")])
                ) {
                    isSaleSupportArchived = true;
                }
            });
        });
    } catch (error) {
        ErrorToast(`${t("There's an error")}`);
    }
    return isSaleSupportArchived;
}

export function ArchivedPaymentMethodFranchise(shopsPaymentMethodsData: any) {
    let idsAssociated: any[] = [];
    try {
        if (shopsPaymentMethodsData !== undefined) {
            shopsPaymentMethodsData.forEach((element: any) => {
                idsAssociated.push(element.id);
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
    } catch (error) {
        console.log(error);
    }
    return idsAssociated;
}

export function ArchivedPaymentMethod(shopsPaymentMethodsData: any) {
    let idsAssociated: any[] = [];
    if (shopsPaymentMethodsData !== undefined) {
        Object.values(shopsPaymentMethodsData).forEach((element: any) => {
            element?.subRows.forEach((el: any) => {
                idsAssociated.push(el.id);
            });
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export const handleOnClickEvent = async (
    setSelectedRows: any,
    selectedRowData: any,
    oneShop: any,
    setIsModalConfirmationOpened: any,
    isModalConfirmationOpened: any,
    shopsPaymentMethodsData: any,
    i18nextLng: any,
    userID: any,
    shopId: any,
    franchiseID: any,
    userData: any,
    operatorID: any,
    uuidUser: any,
    itemsDisable: any,
    fetchGlobal: any
) => {
    try {
        let dataArchive: any[] = [];
        setIsLoading(true);
        setSelectedRows([selectedRowData.selectedRow]);
        if (!oneShop) {
            dataArchive = ArchivedPaymentMethod(shopsPaymentMethodsData);
        } else {
            dataArchive = ArchivedPaymentMethodFranchise(
                shopsPaymentMethodsData
            );
        }

        const isArchived = await isSaleSupportArchived(
            i18nextLng,
            [selectedRowData.selectedRow],
            userID,
            shopId,
            franchiseID,
            fetchGlobal
        );

        if (isArchived) {
            ErrorToast(
                t(
                    "Please note that the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                )!
            );
            setIsLoading(false);
            return;
        }

        const isInArchiveList = dataArchive.includes(
            selectedRowData.selectedRow.id
        );

        if (isInArchiveList && !oneShop) {
            setIsLoading(false);
            setIsModalConfirmationOpened(!isModalConfirmationOpened);
        } else {
            setIsLoading(false);
            handleActivePaymentMethod(
                selectedRowData,
                userData,
                operatorID,
                uuidUser,
                itemsDisable,
                fetchGlobal
            );
        }
    } catch (error) {
        console.log({ error });
        throw error;
    }
};

function ArchivedPaymentMethodFunc(e: any, shopsPaymentMethodsData: any) {
    try {
        let idsAssociated = ["0"];
        if (shopsPaymentMethodsData !== undefined) {
            shopsPaymentMethodsData.forEach((element: any) => {
                element.subRows.forEach((el: any) => {
                    if (el.id === e.id) idsAssociated.push(el.idShop);
                });
            });
        }
        idsAssociated = [...new Set(idsAssociated)];

        return idsAssociated;
    } catch (error) {
        console.log({ error });
        throw error;
    }
}

export async function activePaymentMethod(
    isValidation: boolean,
    selectedRows: any,
    shopsPaymentMethodsData: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    fetchGlobal: any
) {
    try {
        setGlobalDataIsUpdated(false);
        setIsLoading(true);
        let objectData: any = {};
        let data: any = {};
        let shopId: any = [];
        for (let element of Object.values(selectedRows) as any) {
            const id = element.id;
            let shopsArchived = ArchivedPaymentMethodFunc(
                element,
                shopsPaymentMethodsData
            );
            shopId = isValidation ? shopsArchived : ["0"];
            data[id] = {
                designation: element[t("Type of payment method")],
                currency: element.Devise,
                display: element[t("Display name")],
                shopId: shopId,
                saleSupport: element[t("Support de vente")],
                country: element[t("Country")],
                tag: element.Tag,
                isActive: false,
                isArchived: false,
                languages: element.languages,
                advancedDisplayName: element.advancedDisplayName,
            };
        }
        objectData = {
            userId: userID,
            shopId,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data,
        };
        try {
            const result: any = await fetchGlobal(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(objectData),
                }
            );

            if (result.error === false) {
                setGlobalDataIsUpdated(true);
                setIsDataUpdated(true);
                setIsLoading(false);
                ShowSuccessToast(
                    t("The Payment method is successfully unarchived")
                );
            }
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
    } catch (error) {
        console.log({ error });
    }
}

export function handleConsultPaymentMethod({
    isEdited,
    isActionsClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    clearData,
    clearMultiCustomSelectionData,
    setPaymentMethod,
    selectedRowData,
    setIsAddChoiceClicked,
    setIsInputUpdated,
    isInputUpdated,
    setIsConsult,
}: any) {
    try {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                clearData();
                clearMultiCustomSelectionData();
                setPaymentMethod(selectedRowData.selectedRow);
            });
        } else {
            setPaymentMethod(selectedRowData.selectedRow);
            setIsAddChoiceClicked(true);
            setIsInputUpdated(!isInputUpdated);
        }
        setIsConsult(true);
    } catch (error) {
        throw error;
    }
}

export function handleUpdatePaymentMethodClick({
    isEdited,
    isActionsClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    clearData,
    clearMultiCustomSelectionData,
    setPaymentMethod,
    selectedRowData,
    setIsAddChoiceClicked,
    setIsInputUpdated,
    isInputUpdated,
}: any) {
    try {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                clearData();
                clearMultiCustomSelectionData();
                setPaymentMethod(selectedRowData.selectedRow);
            });
        } else {
            setPaymentMethod(selectedRowData.selectedRow);
            setIsAddChoiceClicked(true);
            setIsInputUpdated(!isInputUpdated);
        }
    } catch (error) {
        throw error;
    }
}

export function handleStatePaymentMethodActivation({
    e,
    isEdited,
    isActionsClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsAddChoiceClicked,
    setMessage,
    t,
    choiceState,
    setYesFunction,
    setPaymentMethodState,
    userData,
    selectedRowData,
    operatorID,
    uuidUser,
    itemsDisable,
    setActivationDeactivationMessageModalOpened,
    setIsLoading,
    fetchGlobal,
}: any) {
    try {
        setIsLoading(true);

        const confirmationMessage = choiceState
            ? t(
                  "Caution, the Payment method may be used by other modules.\n Would you like to confirm the deactivation of the selected Payment method?"
              )
            : t(
                  "Would you like to confirm the activation of the selected Payment method?"
              );

        const confirmAction = () => {
            setPaymentMethodState(!choiceState);
            handleStateChange(
                e,
                userData,
                selectedRowData,
                operatorID,
                uuidUser,
                choiceState,
                itemsDisable,
                fetchGlobal
            );
        };

        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                setIsAddChoiceClicked(false);
                setMessage(confirmationMessage);
                setYesFunction(() => confirmAction());
                setActivationDeactivationMessageModalOpened(true);
            });
        } else {
            setIsAddChoiceClicked(false);
            setMessage(confirmationMessage);
            setYesFunction(() => confirmAction());
            setActivationDeactivationMessageModalOpened(true);
        }

        setIsLoading(false);
    } catch (error) {
        throw error;
    }
}

export function handlePaymentMethodDeletion({
    isEdited,
    isActionsClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsAddChoiceClicked,
    setIsLoading,
    handleTrashButtonClicked,
    selectedRowData,
    shopsPaymentMethodsData,
    franchiseID,
    isArchivedValidationModalOpened,
    setIsArchivedValidationModalOpened,
    setPaymentMethod,
    clearData,
    clearMultiCustomSelectionData,
    fetchGlobal,
}: any) {
    try {
        setIsLoading(true);

        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(async () => {
                setIsAddChoiceClicked(false);
                setIsEdited(false);
                handleTrashButtonClicked(
                    selectedRowData.selectedRow,
                    shopsPaymentMethodsData,
                    franchiseID,
                    isArchivedValidationModalOpened,
                    setIsArchivedValidationModalOpened,
                    fetchGlobal
                );
                setPaymentMethod([]);
                setIsAddChoiceClicked(false);
                clearData();
                clearMultiCustomSelectionData();
            });
            setIsLoading(false);
        } else {
            setIsLoading(false);
            setIsAddChoiceClicked(false);
            handleTrashButtonClicked(
                selectedRowData.selectedRow,
                shopsPaymentMethodsData,
                franchiseID,
                isArchivedValidationModalOpened,
                setIsArchivedValidationModalOpened,
                fetchGlobal
            );
        }
    } catch (error) {
        throw error;
    }
}

export function handlePaymentMethodHistory({
    isEdited,
    isActionsClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setPaymentMethod,
    setIsAddChoiceClicked,
    clearData,
    clearMultiCustomSelectionData,
    setSelectedHistoryPaymentMethods,
    setSelectedPaymentMethods,
    selectedRowData,
}: any) {
    try {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsHistoryModalOpened(!isHistoryModalOpened);
                setIsEdited(false);
                setPaymentMethod([]);
                setIsAddChoiceClicked(false);
                clearData();
                clearMultiCustomSelectionData();
            });
            setSelectedHistoryPaymentMethods(selectedRowData.selectedRow);
            setSelectedPaymentMethods([
                {
                    [selectedRowData.selectedRow.idShop]:
                        selectedRowData.selectedRow.id,
                },
            ]);
        } else {
            setIsHistoryModalOpened(!isHistoryModalOpened);
            setSelectedHistoryPaymentMethods(selectedRowData.selectedRow);
            setSelectedPaymentMethods([
                {
                    [selectedRowData.selectedRow.idShop]:
                        selectedRowData.selectedRow.id,
                },
            ]);
        }
    } catch (error) {
        throw error;
    }
}

export async function handleArchivePaymentMethods(
    value: boolean,
    selectedRows: any,
    franchiseID: any,
    setIsArchivedValidationModalOpened: any,
    userID: any,
    operatorID: any,
    uuidUser: any,
    setIsValidateClicked: any,
    fetchGlobal: any
) {
    try {
        setIsLoading(true);
        let isSomeConsumed = false;
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`;
        if (selectedRows.length > 0) {
            let data: any = {};
            let shopIds: any = [];
            for (let el of selectedRows) {
                if (!shopIds.includes(el.idShop)) {
                    shopIds.push(el.idShop);
                }
            }
            const queryParam = encodeURIComponent(JSON.stringify(shopIds));
            let dataConsumed: any = await isInformationModeConsumed(
                queryParam,
                franchiseID,
                fetchGlobal
            );
            for (let el of selectedRows) {
                let isConsumed =
                    Object.keys(dataConsumed).includes(el.idShop) &&
                    dataConsumed[el.idShop].some(
                        (elt: any) => elt.id === el.id
                    );

                if (isConsumed === true) {
                    isSomeConsumed = true;
                } else {
                    isSomeConsumed = false;
                    data[el.id] = {
                        designation: el[t("Type of payment method")],
                        currency: el.Devise,
                        display: el[t("Display name")],
                        shopId: [el.idShop],
                        saleSupport: el[t("Support de vente")],
                        country: el.Pays,
                        tag: el.Tag,
                        isActive:
                            el.idShop === "0" && value === false ? true : false,
                        isArchived: value,
                        advancedDisplayName: el.advancedDisplayName,
                    };
                }
            }
            if (!isSomeConsumed) {
                let objectData: any = {
                    userId: userID,
                    shopId: [selectedRows[0].idShop],
                    franchiseId: franchiseID,
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    data,
                };
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(objectData),
                };

                const result: any = await fetchGlobal(apiUrl, requestOptions);
                if (result.error) {
                    ErrorToast(`${t("There's an error")}`);
                }
                setIsValidateClicked(false);
                setIsArchivedValidationModalOpened(false);
                setIsLoading(false);
                setIsDataUpdated(true);
                ShowSuccessToast(
                    !value
                        ? `${t(
                              "The Payment method is successfully unarchived"
                          )!}`
                        : `${t("The Payment method is successfully archived")!}`
                );
            } else {
                ErrorToast(
                    t(
                        "Please note, you cannot archive an element used in a template"
                    )
                );
                setIsLoading(false);
            }
        }
    } catch (error) {
        throw error;
    }
}

export function paymentMethodExistInShops(
    shopsPaymentMethodsData: any,
    selectedRows: any,
    isArchivedPaymentMethodsClicked: any,
    setIsArchivedValidationModalOpened: any,
    oneShop: any,
    franchiseID: any,
    userID: any,
    operatorID: any,
    uuidUser: any,
    setIsValidateClicked: any,
    fetchGlobal: any
) {
    try {
        let isIdExist;
        let idsAssociated: any = [];
        shopsPaymentMethodsData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.id);
            });
        });

        selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.id)) {
                isIdExist = true;
            }
        });
        if (isIdExist === true && !oneShop) {
            ErrorToast(
                `${t(
                    "Please note that you cannot archive an item assigned to stores."
                )!}`
            );
            setIsLoading(false);
        } else {
            if (!isArchivedPaymentMethodsClicked) {
                setIsArchivedValidationModalOpened(true);
                setIsLoading(false);
            } else {
                handleArchivePaymentMethods(
                    true,
                    selectedRows,
                    franchiseID,
                    setIsArchivedValidationModalOpened,
                    userID,
                    operatorID,
                    uuidUser,
                    setIsValidateClicked,
                    fetchGlobal
                );
            }
        }
    } catch (error) {
        throw error;
    }
}

export function PaymentMethodExistInShopsActivated(
    shopsPaymentMethodsData: any,
    selectedRows: any,
    isModalConfirmationOpened: any,
    setIsModalConfirmationOpened: any,
    isArchivedPaymentMethodsClicked: any,
    setIsArchivedValidationModalOpened: any,
    franchiseID: any,
    userID: any,
    operatorID: any,
    uuidUser: any,
    setIsValidateClicked: any,
    oneShop: boolean,
    fetchGlobal: any
) {
    try {
        let isIdExist;
        let idsAssociated: any = [];
        shopsPaymentMethodsData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.id);
            });
        });

        selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.id)) {
                isIdExist = true;
            }
        });
        if (isIdExist === true && !oneShop) {
            setIsModalConfirmationOpened(!isModalConfirmationOpened);
            setIsLoading(false);
        } else {
            setIsLoading(false);
            !isArchivedPaymentMethodsClicked
                ? setIsArchivedValidationModalOpened(true)
                : handleArchivePaymentMethods(
                      false,
                      selectedRows,
                      franchiseID,
                      setIsArchivedValidationModalOpened,
                      userID,
                      operatorID,
                      uuidUser,
                      setIsValidateClicked,
                      fetchGlobal
                  );
        }
    } catch (error) {
        throw error;
    }
}

export function canceledHandleButton(
    isEdited: any,
    setIsEdited: any,
    setDataChoice: any,
    setIsAddChoiceClicked: any,
    isAddChoiceClicked: any,
    setIsConsult: any,
    isActionsClicked: any
) {
    try {
        if (isEdited === true) {
            setActions(() => {
                setDataChoice([]);
                setIsActionsClicked(false);
                setIsAddChoiceClicked(false);
                clearData();
                setIsEdited(false);
                clearMultiCustomSelectionData();
            });
            setIsActionsClicked(!isActionsClicked);
        } else {
            setDataChoice([]);
            setIsAddChoiceClicked(!isAddChoiceClicked);
            clearData();
            clearMultiCustomSelectionData();
        }
        setIsConsult(false);
    } catch (error) {
        throw error;
    }
}

export async function fetchPaysIfNeeded(
    listOfCountry: any[],
    dispatch: any,
    i18nextLng: string,
    fetchGlobal: any
) {
    if (!listOfCountry || listOfCountry.length === 0) {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pays`;

        const dataUrl: any = await fetchGlobal(apiUrl, {
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
            method: "GET",
        });

        if (dataUrl.error) {
            throw new Error("Error fetching country list!");
        }

        const listPays = dataUrl.data.map((element: any) => ({
            label: element["Designation"],
            value: element.Id,
            frDesignation: element.frenchDesignation,
        }));

        dispatch(setPays(listPays));
    }
}
